
const OurWorkCards = ({Image}) => {
    return(
        <div className="cards-container">
            <img src={Image} />
        </div>
    )
}

export default OurWorkCards;